import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { GridToolComponent } from '../grid-toolbar-component/grid-tool.component';
import { GridExportCsvOptions } from '../../models/grid-toolbar-options';

@Component({
    selector: 'app-export-csv',
    imports: [MatIconModule, MatButton],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './export-csv.component.html',
})
export class ExportCsvComponent extends GridToolComponent {
    @Input() refreshDataForExport!: () => void;
    @Input() options?: GridExportCsvOptions = undefined;

    export() {
        this.refreshDataForExport();

        let csvExportParams;
        if (this.options?.prependContentFn) {
            csvExportParams = {
                ...this.options,
                prependContent: this.options.prependContentFn(),
            };
        }

        this.gridApi?.exportDataAsCsv(csvExportParams ?? this.options);
    }
}
